export default "__VITE_ASSET__D4Dr8619__"